export default "__VITE_ASSET__Da$kLPuT__"